/*****
 * ポップアップボックスの表示
 * 
 * <div data-plugin="cookie-popup"></div>
 * <button data-toggle-cookie="popup-hide" data-toggle-value="true">閉じる</button> 
 */

import Cookie from 'js-cookie'

export default function COOKIE_POPUP(popupName="cookie-popup",cookieName="popup-hide") {
  window.load.header.then(() => {
    const $popup = $(`[data-plugin="${popupName}"]`)
    const $toggle = $(`[data-toggle-cookie="${cookieName}"][data-toggle-value]`)
    const value = Cookie.get(cookieName)
    const toggle_popup = (val,dur=200) => {
      switch(val){
        case 'true':
          setTimeout(()=> $popup.hide(),dur); break
        case 'false':
        case 'remove':
          $popup.show(); break
      }
    }
    $popup[value=='true'? 'addClass':'removeClass']('hidden')
    toggle_popup(value)

    $toggle.on('click',e => {
      const data = e.currentTarget.dataset
      const cookie = {name: data.toggleCookie, value: data.toggleValue }
      $popup[cookie.value=='true'? 'addClass':'removeClass']('hidden')
      switch(cookie.value){
        case 'true':
        case 'false':
          Cookie.set(cookie.name,cookie.value); break
        case 'remove':
          Cookie.remove(cookie.name); break
      }
      toggle_popup(cookie.value)
    })
  })
}